export const DOMAIN_AI = "AI";
